<template>
    <div>
        <v-skeleton-loader v-if="loading" type="image" />
        <v-img v-else-if="blobUrl" :src="blobUrl" :width="size" contain></v-img>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "PrivateImage",
    props: {
        id: { type: [String, Number], required: true },
        alt: { type: String, default: "" },
        size: { type: Number, default: 35 }
    },
    data() {
        return {
            blobUrl: null,
            loading: true,
        };
    },
    watch: {
        id: {
            immediate: true,
            handler(newVal) {
                this.loadImage(newVal);
            },
        },
    },
    methods: {
        async loadImage(id) {
            if (!id) return;

            this.loading = true;

            try {
                const response = await axios.get(`/api/v2/resources/${id}`, {
                    responseType: "blob",
                });

                this.blobUrl = URL.createObjectURL(response.data);
            } catch (error) {
                console.error("Erro ao carregar imagem:", error);
            } finally {
                this.loading = false;
            }
        },
    },
    beforeDestroy() {
        if (this.blobUrl) {
            URL.revokeObjectURL(this.blobUrl);
        }
    },
};
</script>